// extracted by mini-css-extract-plugin
export default {"root":"MemberApplication_root__fjUJk"};